import { ReactNode, createContext, useMemo } from 'react';
import { TPanelIdentifier } from '../../eventsController/types';

export const PanelIdentifierContext = createContext<
  TPanelIdentifier | undefined
>(undefined);

export interface TPanelIdentifierProps {
  children: ReactNode;
  id: string;
  name: string;
  title: string;
  type: string;
}

export const PanelIdentifier = ({
  children,
  name,
  id,
  title,
  type,
}: TPanelIdentifierProps) => {
  const contextValue: TPanelIdentifier = useMemo(() => {
    return { panelName: name, panelId: id, panelTitle: title, panelType: type };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PanelIdentifierContext.Provider value={contextValue}>
      {children}
    </PanelIdentifierContext.Provider>
  );
};
